import { createContext, useContext, useEffect, useState } from "react";

const AgeGateContext = createContext(null);
const STORAGE_KEY = "p4p_age_verified_v1";

export const AgeGateProvider = ({ children }) => {
  const [verified, setVerified] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const val = localStorage.getItem(STORAGE_KEY);
      if (val === "true") setVerified(true);
    } catch {}
    setReady(true);
  }, []);

  const confirm = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "true");
    } catch {}
    setVerified(true);
  };

  return (
    <AgeGateContext.Provider value={{ verified, ready, confirm }}>
      {children}
    </AgeGateContext.Provider>
  );
};

export const useAgeGate = () => useContext(AgeGateContext);
